import { useState, useEffect } from "react";
import api from "@/lib/api";
import CrudTable from "@/components/CrudTable";

export default function TeamMasterList() {
  const [nextId, setNextId] = useState("");

  useEffect(() => {
    api.get("/team-generate-id").then((r) => setNextId(r.data.employee_id)).catch(() => {});
  }, []);

  const columns = [
    { key: "employee_id", label: "Employee ID" },
    { key: "name", label: "Name" },
    { key: "email", label: "Google Email" },
    { key: "role", label: "Role", type: "badge" },
    { key: "joining_date", label: "Joined" },
    { key: "status", label: "Status", type: "badge" },
    { key: "contact_number", label: "Contact" },
  ];
  const fields = [
    { key: "employee_id", label: "Employee ID (auto)", type: "text", required: true },
    { key: "name", label: "Name", type: "text", required: true },
    { key: "email", label: "Google Account Email", type: "text", required: true },
    { key: "role", label: "Role", type: "select", options: ["Finance Manager", "Accountant", "Compliance Officer"], required: true },
    { key: "joining_date", label: "Joining Date", type: "date" },
    { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"], required: true },
    { key: "contact_number", label: "Contact Number", type: "text" },
    { key: "remarks", label: "Remarks", type: "textarea", full: true },
  ];

  return (
    <CrudTable
      testid="team" endpoint="team"
      title="Team Master List" subtitle="Manually add Finance team members with a stable auto Employee ID. All downstream data joins on Employee ID, never display name."
      addLabel="Add Team Member" columns={columns} fields={fields}
      defaults={{ status: "Active", employee_id: nextId }}
      onChanged={() => {}}
    />
  );
}
